import React, { useContext, useEffect, useState } from 'react';
import styles from './HousesForm.module.scss';
import HouseList from '../HouseList/HouseList';
import SearchInput from '../../common/SearchInput/SearchInput';
import {
  HandleSelectAllHousesContext,
  HousesFilterContext,
  SelectedItemsContext,
} from '../../../pages/ChangingAllPage/Provider';
import { Checkbox } from 'antd';
// import FilterComponent from "../../common/FilterComponent/FilterComponent";

const HouseFormList = ({ housesFilter }) => {
  return (
    <div className={styles.lists}>
      {Object.keys(housesFilter).map((key) => (
        <HouseList
          key={key}
          streetId={key}
          houseFilter={housesFilter[key]}
        />
      ))}
    </div>
  );
};

const HousesForm = () => {
  const housesFilter = useContext(HousesFilterContext);
  const handleSelectAllHouses = useContext(HandleSelectAllHousesContext);
  const selectedItems = useContext(SelectedItemsContext);

  const [search, setSearch] = useState('');
  const [filteredHouses, setFilteredHouses] = useState(housesFilter);

  const filterBySearch = ({ housesFilter, search }) => {
    const filterObj = {};

    Object.keys(housesFilter).forEach((id) => {
      housesFilter[id].forEach((house) => {
        if (house.building === search) {
          if (id in filterObj) {
            filterObj[id].push(house);
          } else {
            filterObj[id] = [house];
          }
        }
      });
    });

    return filterObj;
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const isAllChecked = () => {
    if (selectedItems && housesFilter) {
      const countFilters = Object.values(housesFilter).reduce(
        (acc, house) => acc + house.length,
        0
      );

      return countFilters === selectedItems.length;
    }
    return true;
  };

  useEffect(() => {
    let newHousesData = {};

    if (Object.keys(housesFilter).length) {
      newHousesData = search.trim()
        ? filterBySearch({ housesFilter, search: search.trim() })
        : housesFilter;
    }

    setFilteredHouses(newHousesData);
  }, [housesFilter, search]);

  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <h3 className={styles.title}>Дома</h3>
      </div>
      <div className={styles.blockHeader}>
        <SearchInput
          placeholder="Поиск по номеру дома"
          value={search}
          onChange={handleSearchChange}
        />
        {/* <FilterComponent /> */}
      </div>
      <div className={styles.blocks}>
        <div>Все дома</div>
        <Checkbox
          className={styles.customCheckboxReg}
          checked={isAllChecked()}
          onChange={(e) => handleSelectAllHouses(e.target.checked)}
        />
      </div>
      <HouseFormList housesFilter={filteredHouses} />
    </div>
  );
};

export default HousesForm;
